export var TypeActionSpendGoldConfirmation;
(function (TypeActionSpendGoldConfirmation) {
    TypeActionSpendGoldConfirmation["Receive"] = "SpendGoldConfirmation > Receive";
    TypeActionSpendGoldConfirmation["Finish"] = "SpendGoldConfirmation > Finish";
})(TypeActionSpendGoldConfirmation || (TypeActionSpendGoldConfirmation = {}));
export var actionSpendGoldConfirmation = function (status) { return ({
    status: status,
    type: TypeActionSpendGoldConfirmation.Receive,
}); };
export var actionSpendGoldConfirmationFinish = function () { return ({
    type: TypeActionSpendGoldConfirmation.Finish,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/spend-gold-confirmation/actionSpendGoldConfirmation.ts
// module id = 344
// module chunks = 3